'use client';

import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

const cookieTypes = [
  { name: 'Cookie Tecnici', required: true, desc: 'Necessari per il funzionamento del sito. Non possono essere disabilitati.', examples: 'Sessione utente, preferenze lingua, token di autenticazione' },
  { name: 'Cookie Analitici', required: false, desc: 'Ci aiutano a capire come gli utenti interagiscono con il sito per migliorare l\'esperienza.', examples: 'Google Analytics, Mixpanel' },
  { name: 'Cookie di Marketing', required: false, desc: 'Utilizzati per mostrare annunci pertinenti e misurare l\'efficacia delle campagne.', examples: 'Google Ads, Facebook Pixel' },
];

export default function CookiePolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-border">
        <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between">
          <Link href="/" className="flex items-center gap-2">
            <AppLogo size={28} />
            <span className="font-semibold text-sm text-foreground">LabCall<span className="text-primary">Manager</span></span>
          </Link>
        </div>
      </nav>
      <div className="max-w-3xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-foreground mb-2">Cookie Policy</h1>
        <p className="text-sm text-muted-foreground mb-8">Ultimo aggiornamento: 1 gennaio 2025</p>
        <div className="space-y-6 text-sm text-muted-foreground leading-relaxed">
          <section>
            <h2 className="text-lg font-bold text-foreground mb-3">Cosa sono i cookie?</h2>
            <p>I cookie sono piccoli file di testo che vengono salvati sul tuo dispositivo quando visiti un sito web. Vengono utilizzati per ricordare le tue preferenze, mantenere la sessione attiva e raccogliere informazioni statistiche.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-foreground mb-3">Tipologie di cookie utilizzati</h2>
            <div className="space-y-4">
              {cookieTypes?.map((ct) => (
                <div key={ct?.name} className="p-4 rounded-xl border border-border">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="font-semibold text-foreground">{ct?.name}</h3>
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${ct?.required ? 'bg-green-100 text-green-700' : 'bg-muted text-muted-foreground'}`}>
                      {ct?.required ? 'Obbligatori' : 'Opzionali'}
                    </span>
                  </div>
                  <p className="mb-2">{ct?.desc}</p>
                  <p className="text-xs"><strong>Esempi:</strong> {ct?.examples}</p>
                </div>
              ))}
            </div>
          </section>
          <section>
            <h2 className="text-lg font-bold text-foreground mb-3">Come gestire i cookie</h2>
            <p>Puoi gestire le tue preferenze sui cookie in qualsiasi momento:</p>
            <ul className="list-disc ml-5 mt-2 space-y-1">
              <li>Tramite il banner cookie che appare al primo accesso</li>
              <li>Dalle impostazioni del tuo browser</li>
              <li>Contattandoci a privacy@labcallmanager.com</li>
            </ul>
            <p className="mt-3">Nota: disabilitare i cookie tecnici potrebbe compromettere il funzionamento del sito.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-foreground mb-3">Cookie di terze parti</h2>
            <p>Utilizziamo servizi di terze parti che possono impostare i propri cookie. Per maggiori informazioni, consulta le rispettive privacy policy:</p>
            <ul className="list-disc ml-5 mt-2 space-y-1">
              <li>Google Analytics: <a href="https://policies.google.com/privacy" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">policies.google.com/privacy</a></li>
              <li>Stripe: <a href="https://stripe.com/privacy" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">stripe.com/privacy</a></li>
            </ul>
          </section>
          <section>
            <h2 className="text-lg font-bold text-foreground mb-3">Contatti</h2>
            <p>Per qualsiasi domanda sulla nostra cookie policy: privacy@labcallmanager.com</p>
          </section>
        </div>
      </div>
    </div>
  );
}
